export default __webpack_public_path__ + "static/media/slider1.c723e1d7.jpg";